import Alpine from 'alpinejs'
import "media-chrome"
import "vimeo-video-element"
import "youtube-video-element"
// import Swiper from 'swiper';
// import { Navigation, Pagination } from 'swiper/modules';
// import 'swiper/css';
import initCkeditors from './ckeditor.js'
import initReveal from './reveal.js'
import initParallax from './parallax.js'
import './main.css'

// ---------------------------------------------------------------------------------------------------- HOT MODULE REPLACEMENT (HMR)
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}

// // ---------------------------------------------------------------------------------------------------- SWIPER
// window.Swiper = Swiper
// Swiper.use([Navigation, Pagination]);

// ---------------------------------------------------------------------------------------------------- ALPINE
window.Alpine = Alpine
Alpine.start();

// ---------------------------------------------------------------------------------------------------- CKEDITOR
// Only does anything on pages with a [data-ckeditor] textarea.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCkeditors)
} else {
  initCkeditors()
}

// ---------------------------------------------------------------------------------------------------- REVEAL ON SCROLL
// Only does anything on pages with a [data-reveal] container.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReveal)
} else {
  initReveal()
}

// ---------------------------------------------------------------------------------------------------- MARGINAL WORD PARALLAX
// Only does anything on pages with a [data-parallax-word] section.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initParallax)
} else {
  initParallax()
}

// ---------------------------------------------------------------------------------------------------- LINKED <details>
// A link to a question in an FAQs block (#faq-…) scrolls to it but leaves it
// shut; open the <details> it points at, on load and on in-page navigation.
function openLinkedDetails() {
  const target = window.location.hash ? document.getElementById(decodeURIComponent(window.location.hash.slice(1))) : null
  if (target instanceof HTMLDetailsElement) target.open = true
}
window.addEventListener('hashchange', openLinkedDetails)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', openLinkedDetails)
} else {
  openLinkedDetails()
}
